import Cookies from "js-cookie";

export const setTokenByKey = cookiedt => {
  Cookies.set(cookiedt.cookiekey, cookiedt.cookievalue);
};
export const removeTokenByKey = cookiename => {
  Cookies.remove(cookiename);
};
export const getCookieByKey = key => {
  const rt = Cookies.get(key);
  if (rt) return rt;
  else return false;
};
